import { render } from "./projectstab.vue?vue&type=template&id=2b6d30d8&scoped=true"
import script from "./projectstab.vue?vue&type=script&lang=js"
export * from "./projectstab.vue?vue&type=script&lang=js"

import "./projectstab.vue?vue&type=style&index=0&id=2b6d30d8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6d30d8"]])

export default __exports__